import Avatar from "../../components/Avatar";
import {
  createFriendChat,
  friendChatVisible,
  friendChatOpen,
  useFriendChat,
} from "../../redux/friendChat";
import { IoClose } from "react-icons/io5";
import { FaMinus } from "react-icons/fa";
import dynamic from "next/dynamic";
import { useUser } from "../../redux/user";
import { CHAT_USER } from "@chesshotel/constants";
import { api } from "../../services/api";
import { FriendWs } from "../../services/wsOutRoutes";
import { useFriends } from "@/redux/friends";

const Chat = dynamic(() => import("../../components/Chat"));

export default function FriendChat() {
  const { friendList } = useFriends();

  const { chatMessages, friendId, visible, open, unreadMessages } =
    useFriendChat();

  const { username } = useUser();

  const friend = friendList.find((friend) => friend.id === friendId);

  if (!friend || !visible) {
    return null;
  }

  function sendChat(msg: string, friendId: number, friendUsername: string) {
    FriendWs.sendChat({ msg, username: friendUsername });
    createFriendChat({ msg, friendId, type: CHAT_USER });
    api.post("/friends/friendchat", { msg, friendId, friendUsername });
  }

  const badgeCount = unreadMessages[friend.id] || 0;

  const chatProps = {
    chatMessages: chatMessages[friend.id] || [],
    username,
    opponentUsername: friend.username,
    sendChat: (msg: string) => sendChat(msg, friend.id, friend.username),
  };

  return (
    <div className="fixed bottom-0 z-50 bg-white border border-gray-100 shadow-lg right-7 w-72 rounded-t-md">
      <div
        className={`flex items-center border-b border-gray-100 justify-between w-full p-3
      ${
        !open
          ? "bg-gray-100 hover:bg-gray-50 hover:border-gray-50"
          : "bg-transparent"
      }
      `}
        onClick={() => !open && friendChatOpen(!open)}
      >
        <div className="flex items-center space-x-1.5">
          <div className="relative">
            <Avatar
              className={open ? "w-11 h-11" : "w-8 h-8 text-xs"}
              fbId={friend.fbId}
              avatarId={friend.avatarId}
              avatarType={friend.avatarType}
              id={friend.id}
              status={friend.online ? "online" : "offline"}
            />
            {!open && badgeCount > 0 && (
              <div className="absolute flex items-center justify-center w-4 h-4 text-xs text-white bg-red-500 rounded-full -top-1 -right-1">
                {badgeCount}
              </div>
            )}
          </div>
          <div>{friend.username}</div>
        </div>
        <div className="flex items-center self-start space-x-1">
          {open && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                friendChatOpen(false);
              }}
              className="btn btn-icon btn-icon-sm btn-goast"
            >
              <FaMinus />
            </button>
          )}

          <button
            onClick={() => friendChatVisible(false)}
            className="btn btn-icon btn-icon-sm btn-goast"
          >
            <div className="text-lg">
              <IoClose />
            </div>
          </button>
        </div>
      </div>
      <div className={`h-80 w-full p-0 ${open ? "flex" : "hidden"}`}>
        {visible && open && <Chat {...chatProps} />}
      </div>
    </div>
  );
}
